import ModalDialog from '_premierworld/js/Classes/ModalDialog';

window.ModalDialog = ModalDialog;
export default ModalDialog;